import React, { useState } from "react";
import "./PaymentGatewayModal.css";

const PaymentGatewayModal = ({
  isOpen,
  onClose,
  preferredCurrency,
  paymentData,
  onPaymentInitiate,
}) => {
  const [loadingGateway, setLoadingGateway] = useState(null);

  if (!isOpen) return null;

  const isNairaEvent = preferredCurrency === "NGN";
  const isDollarEvent = preferredCurrency === "USD";

  const handleGatewaySelect = async (gateway) => {
    setLoadingGateway(gateway);

    try {
      await onPaymentInitiate(gateway, paymentData, () => {
        if (gateway !== "moniepoint") setLoadingGateway(null);
      });
    } catch (e) {
      alert("Failed to initiate payment. Please try again.");
      setLoadingGateway(null);
    }
  };

  return (
    <div
      className="payment-gateway-modal-overlay"
      onClick={loadingGateway ? undefined : onClose}
    >
      <div
        className="payment-gateway-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="gateway-modal-close-button"
          // disabled={loadingGateway !== null}
        >
          ×
        </button>

        <div className="payment-gateway-modal-body">
          <h2 className="payment-gateway-title">Choose Payment Method</h2>
          <p className="payment-gateway-subtitle">
            Select your preferred payment gateway to complete the transaction
          </p>

          <div className="payment-gateway-options">
            {isNairaEvent && (
              <>
                <button
                  className={`gateway-option ${
                    loadingGateway === "moniepoint" ? "loading" : ""
                  }`}
                  onClick={() => handleGatewaySelect("moniepoint")}
                  disabled={loadingGateway !== null}
                >
                  <img
                    src="/images/moniepoint_logo.png"
                    alt="Moniepoint"
                    className="gateway-logo"
                  />
                  <span className="gateway-name">Pay with Monnify</span>
                  {loadingGateway === "moniepoint" && (
                    <div className="gateway-loader"></div>
                  )}
                </button>

                <button
                  className={`gateway-option ${
                    loadingGateway === "paystack" ? "loading" : ""
                  }`}
                  onClick={() => handleGatewaySelect("paystack")}
                  disabled={loadingGateway !== null}
                >
                  <img
                    src="/images/paystack_logo.png"
                    alt="Paystack"
                    className="gateway-logo"
                  />
                  <span className="gateway-name">Pay with Paystack</span>
                  {loadingGateway === "paystack" && (
                    <div className="gateway-loader"></div>
                  )}
                </button>
              </>
            )}

            {isDollarEvent && (
              <button
                className={`gateway-option ${
                  loadingGateway === "stripe" ? "loading" : ""
                }`}
                onClick={() => handleGatewaySelect("stripe")}
                disabled={loadingGateway !== null}
              >
                <img
                  src="/images/stripe.png"
                  alt="Stripe"
                  className="gateway-logo"
                />
                <span className="gateway-name">Pay with Stripe</span>
                {loadingGateway === "stripe" && (
                  <div className="gateway-loader"></div>
                )}
              </button>
            )}
          </div>

          <div className="payment-amount-display">
            <span className="amount-label">Total Amount:</span>
            <span className="amount-value">
              {preferredCurrency === "NGN" ? "₦" : "$"}
              {paymentData?.totalAmount?.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentGatewayModal;
